import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";
import RiderHeader from "./RiderHeader";

const RiderLayout = () => {
  const { isRider, loading, user } = useAuth();

  // Show loading skeleton while authentication is being determined
  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <div className="border-b">
          <Skeleton className="h-16 w-full" />
        </div>
        <div className="p-6">
          <div className="space-y-4">
            <Skeleton className="h-8 w-64" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Skeleton className="h-32 w-full" />
              <Skeleton className="h-32 w-full" />
              <Skeleton className="h-32 w-full" />
            </div>
            <Skeleton className="h-64 w-full" />
          </div>
        </div>
      </div>
    );
  }

  // Redirect non-riders to appropriate page
  if (!isRider) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <RiderHeader />
      <main className="pt-16">
        <Outlet />
      </main>
    </div>
  );
};

export default RiderLayout;